import React from "react";
import { Tag } from "../../../types";

export interface TagPickerProps {
  /** The tags currently assigned, already resolved to full tag records. */
  selectedTags: Tag[];
  /**
   * Open (or close) the dialog's shared tag popover against the trigger. The
   * popover itself lives at the dialog root because the task and sub-task
   * surfaces share one instance.
   */
  onToggleTagPopover: (anchor: HTMLElement) => void;
}

/**
 * The tag control in the dialog's metadata column: the assigned-tag chips and
 * the button that opens the tag popover. Shared by the task and sub-task
 * surfaces, which render it identically from different tag sources.
 */
const TagPicker: React.FC<TagPickerProps> = ({
  selectedTags,
  onToggleTagPopover,
}) => (
  <div>
    <label className="block text-xs font-medium text-warm-text-tertiary mb-2 uppercase tracking-wider">
      Tags
    </label>
    <div className="flex flex-wrap gap-2">
      {selectedTags.map((tag) => (
        <span
          key={tag.id}
          className="px-2.5 py-1 rounded-full text-xs font-medium"
          style={{ backgroundColor: tag.color, color: "white" }}
        >
          {tag.name}
        </span>
      ))}
      <button
        onClick={(e) => onToggleTagPopover(e.currentTarget)}
        className="px-2.5 py-1 bg-warm-bg-elevated border border-warm-border hover:border-warm-blue/50 dark:hover:border-warm-blue/50 text-warm-text-secondary rounded-full text-xs transition-all duration-150 ease-in-out"
      >
        + Add
      </button>
    </div>
  </div>
);

export default TagPicker;
